<template>
  <span :class="classes">
    {{ title }}
    <div
      class="tool-tip"
      v-if="copy.length !== 0"
      :class="{ '--is-active': shownTooltip }"
    >
      <span
        class="tool-tip__icon +text-center"
        :id="tooltipIconId"
        @click.stop.prevent.capture="showTooltip"
        >i</span
      >
      <div
        class="tool-tip__box --right"
        v-show="shownTooltip"
        @click.stop="hideTooltip"
      >
        <div class="tool-tip__arrow"></div>
        <template v-for="(item, index) in copy">
          <h4 v-if="item.copyTitle" :key="index">{{ item.copyTitle }}</h4>
          <p :key="`${index}a`">{{ item.copy }}</p>
        </template>
      </div>
    </div>
  </span>
</template>

<script>
import eventHub from 'apps/bankrate-events'

//////////////////////////////////////////////////////////////////////////////
// @DEPRECATED - Rewrite or clean up for any future use - REMOVE EVENTBUS
// Can also potentially merge this and the other tooltip component into one
//////////////////////////////////////////////////////////////////////////////

export default {
  props: {
    copy: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      require: true
    },
    classes: {
      type: String,
      default: ''
    }
  },

  data: function() {
    return {
      shownTooltip: false
    }
  },

  created: function() {
    eventHub.$on('tooltip::close', this.hideTooltip)
  },

  computed: {
    tooltipIconId: function() {
      return this.title + 'TT'
    }
  },

  methods: {
    showTooltip: function() {
      eventHub.$emit('tooltip::close')

      if (this.shownTooltip === true) {
        this.shownTooltip = false
      } else {
        this.shownTooltip = true
      }
    },
    hideTooltip: function() {
      this.shownTooltip = false
    }
  }
}
</script>
